export default __webpack_public_path__ + "static/media/heroanimation1.235a0570.png";